import { useRef, useState } from 'react';
import './Tratamentos.css';

const tratamentosData = [
    {
        id: 1,
        nome: 'Processamento Auditivo Central (PAC)',
        descricao: `É a forma como o cérebro interpreta e organiza os sons que chegam no ouvido, ou seja, a pessoa escuta mas pode ter dificuldade para entender, interpretar e até dar sentido ao que ouviu.

Como você pode perceber esta alteração?

• Pedir para repetir com frequência (o quê?, hã?)
• Trocar sons parecidos (p-b, f-v, t-d, r-l) na fala ou na escrita

Dificuldades:
• entender a fala em ambiente ruidoso
• seguir ordens
• dificuldade de atenção
• localizar de onde vem o som
• aprender leitura e escrita em crianças`,
        categoria: 'Audiologia',
        imagem: '/PAC.webp'
    },
    {
        id: 2,
        nome: 'Reabilitação Vestibular',
        descricao: `É um tratamento de reorganização neurovestibular que estimula os órgãos do equilíbrio (ouvido interno) e o cérebro para compensar as alterações que causam sintomas de tontura, através de exercícios individualizados e manobras específicas.`,
        categoria: 'Audiologia',
        imagem: '/REAB.webp'
    },
    {
        id: 3,
        nome: 'Zumbido',
        descricao: `Tratamento não invasivo que complementa e potencializa a terapia fonoaudiológica.

Indicado para:
• Trocas na fala
• Alteração no desenvolvimento da linguagem
• Problemas de aprendizagem
• Baixo rendimento escolar
• Transtorno do processamento auditivo
• TDAH
• Usuários de aparelho auditivo
• Implante coclear
• Hipersensibilidade ao som`,
        categoria: 'Audiologia',
        imagem: '/Zumbido.webp'
    },
    {
        id: 4,
        nome: 'NeuroEstimulação Auditiva SENA©',
        descricao: `Na NeuroAudio a equipe realiza tratamento terapêutico com:

• Fotobiomodulação
• Estimulação elétrica transcraniana (TDCS)
• Sons dicóticos
• Exercícios sonoros
• Reabilitação vestibular quando há tontura associada`,
        categoria: 'Audiologia',
        imagem: '/SENA.jpg'
    }
];

const Tratamentos = () => {
    const carrosselRef = useRef(null);
    const [filtroAtivo, setFiltroAtivo] = useState('Todos');

    const tratamentosFiltrados =
        filtroAtivo === 'Todos'
            ? tratamentosData
            : tratamentosData.filter(
                (tratamento) => tratamento.categoria === filtroAtivo
            );

    const scrollEsquerda = () => {
        carrosselRef.current.scrollBy({
            left: -670,
            behavior: 'smooth'
        });
    };

    const scrollDireita = () => {
        carrosselRef.current.scrollBy({
            left: 670,
            behavior: 'smooth'
        });
    };

    return (
        <div className="secao-tratamentos">

            <div className="titulo-descricao d-flex flex-column gap-3">
                <h1 className="titulo">Tratamentos e Serviços</h1>
                <p className={"px-2"}>Escolha uma área para ver os tratamentos relacionados</p>
            </div>

            <div className="carrossel-tratamentos">

                <button className="seta seta-esquerda" onClick={scrollEsquerda}>
                    ⬅
                </button>

                <div className="cards-tratamentos-container py-3" ref={carrosselRef}>
                    {tratamentosFiltrados.map((tratamento) => (
                        <div className="card-tratamentos" key={tratamento.id}>
                            <img
                                src={tratamento.imagem}
                                className="imagem-cards-tratamento"
                                alt={tratamento.nome}
                            />
                            <div className="nome-descricao-tratamento">
                                <span className="nome-tratamento">{tratamento.nome}</span>
                                <span className="descricao-tratamento">
                  {tratamento.descricao}
                </span>
                            </div>
                        </div>
                    ))}
                </div>

                <button className="seta seta-direita" onClick={scrollDireita}>
                    ⮕
                </button>

            </div>
        </div>
    );
};

export default Tratamentos;
